import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../contexts/NotificationContext';
import { supabase } from '../services/supabase';

const InviteConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showNotification } = useNotification();
  const { t } = useTranslation();

  useEffect(() => {
    const confirmInvite = async () => {
      const params = new URLSearchParams(location.hash.substring(1)); // Extract parameters from the hash
      const token = params.get('access_token'); // Get the access token

      if (token) {
        const { error } = await supabase.auth.verifyOtp({
          email: 'milasionut+33@gmail.com', // Provide the email if needed
          token: token,
          type: 'email', // Specify the type as 'email'
        });
        if (error) {
          console.error('Error confirming invite:', error.message);
          showNotification(t('invite.error_confirming'), 'error');
        } else {
          // Store the token if needed
          localStorage.setItem('access_token', token); // Store the token in local storage
          showNotification(t('invite.confirmed_successfully'), 'success');
          // Redirect to a clean URL
          navigate('/success'); // Redirect to a success page
        }
      }
    };

    confirmInvite();
  }, [location.hash, navigate]); // Add location.hash to dependencies

  return (
    <div>
      <h1>{t('invite.processing')}</h1>
    </div>
  );
};

export default InviteConfirmation;
